import {baseUrl} from '../meta.json';
import {mapObject, obtainLanguage, clone, arrayWithoutDublicates} from './utils';
import {domains, languages} from './data/constants.json';

export const defaultScreenBreakpoint = 750;
const specification = {
  baseUrl: {
    default: baseUrl || '',
    parser: value => String(value)
  },
  supportedLanguages: {
    default: Object.keys(languages),
    parser: value =>
      arrayWithoutDublicates(
        (typeof value === 'string' ? value.split(' ') : Array.isArray(value) ? value : Object.keys(languages))
          .filter(language => language && language in languages))
  },
  language: {
    default: obtainLanguage(),
    parser: value => value in languages ? value : 'en'
  },
  forceView: {
    default: null, // can be null, 'desktop' or 'mobile'
    parser: value => ['desktop', 'mobile'].indexOf(value) >= 0 ? value : null
  },
  screenBreakpoint: {
    default: defaultScreenBreakpoint,
    parser: value => parseInt(value) >= 0 ? parseInt(value) : defaultScreenBreakpoint
  },
  postLogin: {
    default: `https://${domains.wix}/my-account/sites/`,
    parser: value => String(value)
  },
  postSignUp: {
    default: `https://${domains.wix}/new/account/`,
    parser: value => String(value)
  },
  hostPage: {
    default: null, // can be 'homepage', 'templates', 'editor', 'verticals', 'music' or null
    parser: value => ['homepage', 'templates', 'editor', 'verticals', 'music'].indexOf(value) >= 0 ? value : null
  }
};

export const useMobileVersion = config =>
  config.forceView ? config.forceView === 'mobile' : window.innerWidth < config.screenBreakpoint;

export const getDefault = () =>
  Object.assign({}, mapObject(specification, value => value.default));

export const sanitize = (input = {}) => {
  const output = mapObject(specification,
    (value, key) => input[key] === undefined ? clone(value.default) : value.parser(input[key]));
  if (output.supportedLanguages.indexOf(output.language) < 0) {
    output.language = 'en';
  }
  return output;
};

export const defaultProfileImage = config =>
  `${config.baseUrl}assets/default-profile-image.svg`;

export const obtainFromDOM = (artifact = 'marketing-header-and-footer') => {
  const node = document.querySelector(`script[data-artifact=${artifact}]`);
  if (!node) {
    console.warn('Cannot obtain header and footer config from DOM, fallback to default');
    return getDefault();
  }
  const config = {};
  Object.keys(node.dataset || {})
    .filter(dataAttributeName => dataAttributeName.indexOf('config') === 0)
    .forEach(dataAttributeName => {
      let key = dataAttributeName.substr(6);
      key = key.charAt(0).toLowerCase() + key.slice(1);
      config[key] = node.dataset[dataAttributeName];
      config.baseUrl = node.src.substr(0, node.src.indexOf('app.bundle'));
    });
  return sanitize(config);
};



// WEBPACK FOOTER //
// ./config.js